<template>
  <section class="facilities" :class="{ desktop: $isDesktop }">
    <template v-for="facility in superFacilities">
      <span
        v-if="facility.slug === 'adults-only'"
        :key="facility.slug"
        class="facility adults-only"
        ><img
          loading="lazy"
          src="@/assets/images/adults.svg"
          width="15"
          height="17"
        />
        {{ facility.name }}
      </span>
    </template>

    <capacity
      :capacity-display="capacityDisplay"
      :is-over-capacity="isOverCapacity"
      :age-restrictions="ageRestrictions"
    />

    <span v-if="pitchtypeRating" class="facility pitch-rating"
      ><img
        src="@/assets/images/user-reviews.svg"
        class="pitch-rating-icon"
      />{{ formatRating(Number(pitchtypeRating)) }}/10
      <translate :tt="{ count: pitchtypeRatecount }" class="count">
        {count} reviews(s)
      </translate></span
    >

    <template v-for="restriction in restrictions">
      <span
        v-if="restriction.amenityIcon === 'no-dogs-allowed'"
        :key="restriction.id"
        class="facility"
        ><img
          loading="lazy"
          src="@/assets/facility-icons/no-dogs-allowed.svg"
          class="no-dogs-allowed"
          width="17"
          height="17"
        />
        {{ restriction.name }}
      </span>
    </template>

    <template v-for="facility in facilities">
      <span
        v-if="facility.slug === 'wifi-at-the-unitpitch'"
        :key="facility.id"
        class="facility"
        ><img
          loading="lazy"
          src="@/assets/facility-icons/wifi.svg"
          width="22"
          height="17"
        />
        {{ facility.name }}
      </span>
    </template>

    <translate v-if="!isByo && bedrooms" :tt="{ bedrooms }" class="facility">
      {bedrooms} bedrooms
    </translate>
  </section>
</template>

<script lang="ts">
import { puNumber } from '~/lang/formatters/puNumber'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import {
  AgeRestrictions,
  CampsiteFacility,
} from '../../../../campsite-details/types'

@Component
class SuperFacilities extends Vue {
  @Prop()
  superFacilities: CampsiteFacility[]

  @Prop()
  capacityDisplay

  @Prop()
  isOverCapacity: boolean

  @Prop()
  restrictions

  @Prop()
  ageRestrictions: AgeRestrictions[]

  @Prop()
  facilities

  @Prop()
  isByo: boolean

  @Prop()
  bedrooms: number

  @Prop()
  pitchtypeRating: number

  @Prop()
  pitchtypeRatecount: number

  formatRating(rating: number) {
    return puNumber(
      rating,
      this.$i18n.locale,
      'maximumFractionDigits:1 minimumFractionDigits:0',
    )
  }
}

export default toNative(SuperFacilities)
</script>
<style scoped>
.facilities {
  align-items: flex-start;
  column-gap: 0.3em;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  flex-wrap: wrap;
  font-size: var(--body);
  justify-content: space-between;
  padding: 1em 0 0.5em;
  column-gap: 0.5em;
}

.facility {
  line-height: 1;
  margin: 0 0 0.5em;
  min-width: 22%;
}

.facility img {
  height: 1.2em;
  width: auto;
  vertical-align: sub;
}

.adults-only {
  font-weight: 600;
}

.adults-only img {
  filter: grayscale(1) brightness(0.5);
}

.pitch-rating.facility {
  display: flex;
  gap: 0.2em;
  align-items: center;
  justify-content: start;
  white-space: nowrap;
}

.facility .pitch-rating-icon {
  width: auto;
  height: 1.1em;
  position: relative;
  top: 1px;
}

.count:after {
  content: ')';
}

.count:before {
  content: '(';
}

/* desktop & tablet */
section.facilities.desktop {
  column-gap: 3em;
  row-gap: 0.75em;
  font-size: inherit;
  justify-content: flex-start;
  padding: 0 0 0.75em;
}

.desktop .facility {
  min-width: unset;
  max-width: none;
  display: inline-block;
}

.desktop .pitch-rating.facility {
  display: flex;
}
</style>
